import * as crypto from 'crypto-js';
import Cookies from 'js-cookie';
import router from 'next/router';
import { getPublicUrl } from '../../appconfig';
import {
  cart_filler_dip_wip_carr_ids,
  cart_filler_ids,
  cart_filler_pillow_dress_ids,
  keywords_check,
  showWidgetQueryParam,
} from '../../components/CartOverlayContainer/Cart/Constants';
import {
  fireEnteredCouponEvent,
  getProductIdsAndName,
} from '../../components/CartOverlayContainer/Cart/instrumentation';
import {
  productFetcher,
  productPriceFetcher,
} from '../../datafetchers/productPage';
import { getUserTypeAndDevice, navigateToCartPage } from '../redirections';
import { getWebUserType } from '../getWebUserType';
import { getNicknameAndUrl, salt } from '../helper';

export const couponHandler = () => {
  const params = new URLSearchParams(window.location.search);
  const queryCoupon = params.get('coupon');
  const cookieCoupon = Cookies.get('coupon_code');
  return cookieCoupon || queryCoupon || null;
};
export const deleteCouponCookieIfQueryInCoupon = () => {
  const params = new URLSearchParams(window.location.search);
  const queryCoupon = params.get('coupon');
  const cookieCoupon = Cookies.get('coupon_code');
  if (queryCoupon && cookieCoupon) {
    Cookies.remove('coupon_code');
  }
};

export const deleteCartItemFromCookie = (id) => {
  const cartCookie = Cookies.get('cart_items');
  if (cartCookie) {
    const cartItemsArray = cartCookie?.split(',');
    let i = cartItemsArray.findIndex((x) => x == id);
    if (i != -1) {
      cartItemsArray.splice(i, 1);
    }
    Cookies.set('cart_items', cartItemsArray, '/');
  }
};

export const prefetchAndOpenCart = async (pageLocation) => {
  await wait(10);
  navigateToCartPage(pageLocation);
};

export const getQueryParamsWithPlatform = () => {
  let params = window?.location?.search;
  const user_type = `user_type=${getWebUserType()}`;
  const browser_id = Cookies.get('browser_id')
    ? Cookies.get('browser_id')
    : null;
  const browserParam = browser_id ? `browser_id=${browser_id}` : '';
  if (params.length === 0) {
    params = '?' + user_type + '&' + browserParam + '&';
  } else {
    params = params + '&' + user_type + '&' + browserParam + '&';
  }
  params = params + 'platform=web_browser';
  return params;
};
export const getCartPricingConversionParams = (data) => {
  let pricing_param =
    data?.priceDetails?.orderMrpTotal +
    ', ' +
    data?.priceDetails?.orderFinalPriceTotal +
    ', ' +
    'NA';
  let conversion_param =
    data?.priceDetails?.orderPriceTotal +
    ', ' +
    data?.priceDetails?.orderDeliveryTotal +
    ', ' +
    data?.priceDetails?.orderFinalPriceTotal;

  return { pricing_param, conversion_param };
};

export const getCartObject = (data) => {
  const { pricing_param, conversion_param } =
    getCartPricingConversionParams(data);
  let params = getQueryParamsWithPlatform();
  const orderSuccessPath = getUserTypeAndDevice() ? 'order' : 'ordersuccess';
  let successCallbackUrl = `${getPublicUrl()}/store/${orderSuccessPath}/{orderId}/success${params}`;
  let failedCallbackUrl = `${getPublicUrl()}/store/${orderSuccessPath}/{orderId}/error${params}`;
  let offer_id =
    data?.cart_products?.[0].hasOwnProperty('cartMinAmountError') &&
    data?.cart_products?.[0]?.cartMinAmountError
      ? ''
      : data?.cart_products?.[0]?.offer_id;
  const products = getFinalProductArray(data);
  const user_offers = {
    name: data?.user_offers?.offers?.[0]?.name,
    length: data?.user_offers?.offers?.length,
  };
  const orderDetails = {
    payment_mode: data?.paymentmethod,
    successCallbackUrl: successCallbackUrl,
    failedCallbackUrl: failedCallbackUrl,
    campaign_id: 'NA',
    query: params,
    query_string: params,
    useGullackPoints: '0',
    type: Cookies.get('offer_user_type'),
    totalGSTonCart: data?.priceDetails?.totalGSTonCart,
  };
  const details = {
    products,
    orderDetails,
  };
  const cart = {
    details,
    offer_id: offer_id,
    total: data?.priceDetails?.orderFinalPriceTotal,
    paymentOption: data?.offerPaymentMethod ? data?.offerPaymentMethod : 0,
    PriceDetail: data.priceDetails,
    user_offers,
    productNickNameAndUrl: getNicknameAndUrl(data),
    conversion_param: conversion_param,
    pricing_param: pricing_param,
    offerUserType: data?.priceDetails?.offerUserType,
  };
  return cart;
};

const getFinalProductArray = (data) => {
  const finalProductArray = [];

  data?.cart_products?.map((element) => {
    let offer_id = element?.offer_id;
    if (element?.offer_id) {
      element?.offered_product.map((Offerdata) => {
        if (Offerdata?.is_sample != '1') {
          finalProductArray.push(
            getproductObject(Offerdata, data?.offerCouponId, offer_id),
          );
        }
      });
    } else {
      if (element?.is_sample != '1') {
        finalProductArray.push(getproductObject(element, data?.offerCouponId));
      }
    }
  });
  return finalProductArray;
};

const getproductObject = (data, offerCouponId = null, offer_id = null) => {
  const couponData = couponHandler();
  const obj = {
    sku_type: data?.type,
    baseDiscount: data?.baseDiscount ? data?.baseDiscount : 0,
    coinDiscount: data?.coinDiscount ? data?.coinDiscount : 0,
    coin_discount: data?.coin_discount ? data?.coin_discount : 0,
    base_discount: data?.base_discount ? data?.base_discount : 0,
    product_value: data?.cart_total ? data?.cart_total : 0,
    delivery: data?.delivery ? data?.delivery : 0,
    delivery_charge: data?.delivery_charge ? data?.delivery_charge : 0,
    delivery_discount: data?.delivery_discount ? data?.delivery_discount : 0,
    discount: data?.discount ? data?.discount : 0,
    finalValue: data?.final_price ? data?.final_price : 0,
    gullack_discount: data?.gullack_discount ? data?.gullack_discount : 0,
    gullack_point_win: data?.gullack_point_win ? data?.gullack_point_win : 0,
    gullack_points_used: data?.gullack_points_used
      ? data?.gullack_points_used
      : 0,
    max_points_usable: data?.max_points_usable ? data?.max_points_usable : 0,
    max_points_usable_original: data?.max_points_usable_original
      ? data?.max_points_usable_original
      : 0,
    order_status: '1',
    offer_id: offer_id,
    price: data?.price ? data?.price : 0,
    product_hindi_name: data?.hindi_name,
    product_id: data?.id,
    product_image: data?.showImage ? data?.showImage : '',
    product_name: data?.name ? data?.name : '',
    product_nickname: data?.nickname ? data?.nickname : '',
    quantity: data?.quantity ? data?.quantity : 0,
    referrer: 'false',
    share_points_given: 0,
    status: '2',
    strikeprice: data?.strikeprice ? data?.strikeprice : 0,
    source_price: data?.source_price ? data?.source_price : 0,
    offer_discount: data?.offer_discount,
    coupon_id: offerCouponId,
    coupon: couponData ? couponData : '',
    useCouponCode: Boolean(couponData),
    payable_gst: data?.payable_gst,
  };
  return obj;
};

export const encryptData = (data) => {
  return crypto.AES.encrypt(JSON.stringify(data), salt).toString();
};

export const decryptData = (ciphertext) => {
  const bytes = crypto.AES.decrypt(ciphertext, salt);
  try {
    return JSON.parse(bytes.toString(crypto.enc.Utf8));
  } catch (err) {
    return null;
  }
};
export const couponQueryParamHandler = async (data, type) => {
  const showOnlyParams = new URLSearchParams(window.location.search);
  const params = new URLSearchParams(window.location.search);
  if (showOnlyParams.has('coupon')) {
    if (type === 'add') {
      showOnlyParams.set('coupon', data?.code);
      params.set(showWidgetQueryParam, true);
      params.set('coupon', data?.code);
    } else if (type === 'remove') {
      showOnlyParams.delete('coupon');
      params.set(showWidgetQueryParam, true);
      params.delete('coupon');
    }
    let fakeParams = '';
    if (showOnlyParams.toString() != '') {
      fakeParams = '?' + showOnlyParams.toString();
    }
    await router.replace(
      window.location.pathname + '?' + params,
      window.location.pathname + fakeParams,
      {
        shallow: true,
      },
    );
  }
};
export const wait = (timeToDelay) =>
  new Promise((resolve) => setTimeout(resolve, timeToDelay));

export const checkAndFireCouponEvent = (data) => {
  const { cart_products, user_offers } = data?.data;
  const { productIds } = getProductIdsAndName(cart_products);
  const userAppliedOffer = user_offers?.offers;
  const couponData = couponHandler();
  if (userAppliedOffer?.length > 0)
    fireEnteredCouponEvent(productIds, couponData, 1);
};

export function encodeUTF(data) {
  // const myString = JSON.stringify(data); // Utf8-encoded string
  const encodedWord = crypto.enc.Utf8.parse(data); // encodedWord Array object
  const encoded = crypto.enc.Base64.stringify(encodedWord); // string: 'NzUzMjI1NDE='
  return encoded;
}

export function decodeUTF(encoded) {
  let decodedData = [];
  for (let value of encoded) {
    let decoded = '';
    if (value != '') {
      try {
        const encodedWord = crypto.enc.Base64.parse(value); // encodedWord via Base64.parse()
        decoded = crypto.enc.Utf8.stringify(encodedWord); // decode encodedWord via Utf8.stringify() '75322541'
      } catch (e) {}
    }
    decodedData.push(decoded);
  }
  return decodedData;
}

export const getCartFillerConstantData = async () => {
  const final_data = [];
  for (let id of cart_filler_dip_wip_carr_ids) {
    const data = await productPriceFetcher(id, 'mon', '', true);
    const data2 = await productFetcher(`api/getProduct/${id}`);
    const { price, strikeprice } = data?.data;
    const { web_url, images, nickname, status, name, delivery } = data2?.data;

    if (status != 4) {
      final_data.push({
        id: id,
        name: name,
        nickname: nickname.split('Mylo').join(''),
        price,
        strikeprice,
        image: images[0],
        web_url,
        delivery: delivery,
      });
    }
  }
  const final_data_2 = [];

  for (let id of cart_filler_pillow_dress_ids) {
    try {
      const data = await productPriceFetcher(id, 'mon', '', true);
      const data2 = await productFetcher(`api/getProduct/${id}`);
      const { price, strikeprice } = data?.data;
      const { web_url, images, nickname, status, name, delivery } = data2?.data;
      if (status != 4) {
        final_data_2.push({
          id: id,
          name: name,
          nickname: nickname.split('Mylo').join(''),
          price,
          strikeprice,
          image: images[0],
          web_url,
          delivery: delivery,
        });
      }
    } catch (e) {}
  }
};

export const getCartFillerProductBasedOnCart = (cartData) => {
  const { productNames } = getProductIdsAndName(
    cartData?.data?.cart_products,
    true,
  );
  let cartFillerItems = [];
  keywords_check.map((keywords) => {
    for (let word of keywords) {
      if (productNames.includes(word)) {
        cartFillerItems = [...cartFillerItems, ...cart_filler_ids[word]];
        break;
      }
    }
  });

  return cartFillerItems;
};

export const getInitialCouponState = (offerList) => {
  return offerList?.length > 0;
  const { productIds } = getProductIdsAndName(cart_products, true);
  const product_ids_arr = productIds.split(',');
  for (let id of product_ids_arr) {
    // if (id === "979")
    return true;
  }
};

export const addDeleteCartFillerProductCookie = (action, id) => {
  const products = localStorage.getItem('cart_filler_products');
  if (action === 'add') {
    if (products) {
      const products_arr = products.split(',');
      products_arr.push(id);
      const updated_data = products_arr.join(',');
      localStorage.setItem('cart_filler_products', updated_data);
    } else {
      localStorage.setItem('cart_filler_products', id);
    }
  } else if (action === 'delete') {
    if (products) {
      const products_arr = products.split(',');
      let i = products_arr.findIndex((x) => x == id);
      if (i != -1) {
        products_arr.splice(i, 1);
      }
      localStorage.setItem('cart_filler_products', products_arr.join(','));
    }
  }
};

export const isProductInCartFillerCookies = (id) => {
  const products = localStorage.getItem('cart_filler_products');
  if (products) {
    const products_arr = products.split(',');
    let i = products_arr.findIndex((x) => x == id);
    if (i === -1) return 0;
    return 1;
  }
  return 0;
};
